// extracted by mini-css-extract-plugin
export var option = "_b2-0";
export var optionCard = "_b2-f";
export var optionContent = "_b2-g";
export var optionIcon = "_b2-i";
export var optionIconBox = "_b2-h";
export var optionLabel = "_b2-j";
export var optionPill = "_b2-m";
export var optionPillBadge = "_b2-p";
export var optionPillIcon = "_b2-n";
export var optionPillLabel = "_b2-o";
export var optionRadio = "_b2-k";
export var optionRadioInner = "_b2-l";
export var optionReveal = "_b2-2";
export var optionRevealDelay0 = "_b2-3";
export var optionRevealDelay1 = "_b2-4";
export var optionRevealDelay10 = "_b2-d";
export var optionRevealDelay11 = "_b2-e";
export var optionRevealDelay2 = "_b2-5";
export var optionRevealDelay3 = "_b2-6";
export var optionRevealDelay4 = "_b2-7";
export var optionRevealDelay5 = "_b2-8";
export var optionRevealDelay6 = "_b2-9";
export var optionRevealDelay7 = "_b2-a";
export var optionRevealDelay8 = "_b2-b";
export var optionRevealDelay9 = "_b2-c";
export var optionSelected = "_b2-1";